import React from 'react';

import Star from '../icons/Star';
import * as styles from './styles/styles.module.scss';

type RatingProps = {
  rating: number;
};

const Rating = ({ rating }: RatingProps): JSX.Element => {
  const active = ![null, undefined].includes(rating);
  const fixedRating = (rating || 0).toFixed(1);

  return (
    <div className={styles.wrapper}>
      <Star active={active} />
      {fixedRating}
    </div>
  );
};

export default Rating;
